import { cn } from "@/lib/cn";

/** A loading placeholder. `aria-hidden`: a screen reader should hear the
 *  region's busy state, not six grey rectangles. */
export function Skeleton({ className }: { className?: string }) {
  return <div aria-hidden className={cn("animate-pulse rounded bg-muted", className)} />;
}

/** Rows of a table that has not arrived yet, at the table's own rhythm. */
export function SkeletonRows({ rows = 5, cols = 4 }: { rows?: number; cols?: number }) {
  return (
    <div className="divide-y divide-border-light">
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex items-center gap-4 px-4 py-3">
          {Array.from({ length: cols }).map((_, c) => (
            <Skeleton key={c} className={cn("h-4", c === 0 ? "w-28" : "flex-1")} />
          ))}
        </div>
      ))}
    </div>
  );
}
